import { IconType } from "react-icons";
import { SideBarItemContainer, SideBarItemLabel } from "./index.styled";

export interface SidebarItemProps {
  id: string;
  icon: IconType;
  label: string;
  onClick?: () => void;
  showFull?: boolean;
  selected?: boolean;
}
const SidebarItem: React.FC<SidebarItemProps> = ({
  id,
  icon: Icon,
  label,
  onClick,
  showFull,
  selected,
}) => {
  return (
    <SideBarItemContainer
      id={id}
      onClick={onClick}
      selected={!!selected}
      showFull={showFull ?? false}
    >
      <Icon />
      <SideBarItemLabel>{label}</SideBarItemLabel>
    </SideBarItemContainer>
  );
};

export default SidebarItem;
